import React, { useCallback, useEffect, useMemo, useState } from "react";
import { PageLayout } from "../components/page-layout";
import { searchListings } from "../services/algolia.service";

export const AboutPage = () => {
  const [taigaTitles, setTaigaTitles] = useState([]);

  const fetchTitles = useCallback(async (keyword, setTitles) => {
    try {
      const response = await searchListings({ keyword, hitsPerPage: 100 });
      const titles = (response?.items || [])
        .map((item) => item.title)
        .filter(Boolean);

      setTitles(titles);
    } catch (error) {
      console.error("Error fetching titles:", error);
      setTitles([]);
    }
  }, []);

  useEffect(() => {
    fetchTitles("taiga takahashi", setTaigaTitles);
  }, [fetchTitles]);

  const taigaCount = Math.max(taigaTitles.length, 1);

  const taigaItems = useMemo(
    () =>
      taigaTitles.map((title, index) => (
        <span
          key={`taiga-${title}-${index}`}
          className="about-page-circle__text"
          style={{ "--index": index, "--count": taigaCount }}
        >
          {title}
        </span>
      )),
    [taigaCount, taigaTitles],
  );

  return (
    <PageLayout>
      <div className="content-layout about-page">
        <div className="about-page-content__body">
          <div className="about-page-about">
            <div className="about-page-about__content">
              <p>
                Japanese second hand marketplaces have notoriously bad search
                experiences. Many customers, professional and recreational
                buyers, check multiple sites multiple times a day for multiple
                brands.
              </p>
              <p>
                This app provides a fast search interface to the Algolia index,
                that is continuously updated by a deployed scraper, running
                postalservice Python package. The scraper tracks new listings
                across the marketplace and feeds them into the Algolia index.
              </p>
              <p>
                The app is built with React, and it uses the Algolia React
                library. The scraper that feeds the Algolia index runs on an
                Oracle virtual machine continuously. One scraping round is
                finished every 4-6 minutes, which means the app&apos;s search
                results are usually no more than 5 minutes old.
              </p>
            </div>
          </div>
        </div>
        <div className="about-page-circles" aria-hidden="true">
          <div className="about-page-circle about-page-circle--taiga">
            <div className="about-page-circle__spinner">{taigaItems}</div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};
